import { useState } from 'react';
import { isMongoObjectId } from 'common/utils';
import { RateEventFeedbackModal } from './rate-event-feedback';
import { RateProgramEventFeedbackModal } from './rate-program-event-feedback';

export type EventFeedbackOptions = EventFeedbackProperties | NoEventFeedbackProperties;
export type EventFeedbackProperties = {
  eventId: string;
  feedback: true;
  onFinish: () => void;
};
export type NoEventFeedbackProperties = { feedback: false };

type P = EventFeedbackOptions;

const EventFeedback = (props: P) => {
  const { feedback: isFeedback } = props;
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(true);

  if (!isFeedback) {
    return null;
  }

  const { eventId, onFinish } = props;

  const closeFeedback = () => {
    setIsFeedbackOpen(false);
    onFinish();
  };

  return isMongoObjectId(eventId) ? (
    <RateEventFeedbackModal
      eventId={eventId}
      isOpened={isFeedbackOpen}
      onCancel={closeFeedback}
      onSuccess={closeFeedback}
    />
  ) : (
    <RateProgramEventFeedbackModal
      eventId={eventId}
      isOpened={isFeedbackOpen}
      onCancel={closeFeedback}
      onSuccess={closeFeedback}
    />
  );
};

export default EventFeedback;
